import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateServiceAreaStatusByFilter } from '../../../api/plan-service-area-override-rules-api'
import type {
  UpdateServiceAreaStatusByFilterBodyDto,
  UpdateServiceAreaStatusByFilterQueryDto,
  UpdateServiceAreaStatusByFilterResponseDto,
} from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

interface Variables {
  query: UpdateServiceAreaStatusByFilterQueryDto
  targetStatus: UpdateServiceAreaStatusByFilterBodyDto['status']
}

export function useUpdateServiceAreaStatusByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateServiceAreaStatusByFilterResponseDto,
    unknown,
    Variables
  >({
    mutationFn: ({ query, targetStatus }) =>
      updateServiceAreaStatusByFilter(query, { status: targetStatus }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
